import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import inactivityLogout from './utils/inactivityLogout';
import Cookies from 'js-cookie';
import { createPinia } from 'pinia'
import { useUserStore } from './stores/user'


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './assets/css/main.css';


// const userStore = useUserStore()
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)


const token = Cookies.get('auth_token')
if (token) {
  // console.log('All registered routes:', router.getRoutes().map(r => r.name));
  // console.log("check tk first")
  const userStore = useUserStore()
  userStore.setToken(token)
  // console.log('token gotten') // <-- This will now print
  userStore.fetchProfile().catch((e) => {
    console.error('Failed to fetch user profile:', e)
  })
  userStore.fetchProfilePhoto().catch((e) => {
    console.error('Failed to fetch user profile Photo:', e)
  })
  userStore.fetchSignature().catch((e) => {
    console.error('Failed to fetch user profile Signature:', e)
  })
}

app.use(router).mount('#app')

router.afterEach((to) => {
    const token = Cookies.get('auth_token');
    if (token && to.meta.requiresAuth) {
        inactivityLogout.setupInactivityTimer();
    }
});
